const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Typography, Grid2 } from '@mui/material';


class ShowmessageContest extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', open: '' };
    }

    render() {
        const { t } = this.props;
        const msg_show = this.props.message;
        if (msg_show != null) {
            return (
                (<Grid2 container className="wpvc_rules_content" size={12} >
                    <Typography variant="subtitle2" component="subtitle2">{t(msg_show)}</Typography>
                </Grid2>)
            );
        } else {
            return ''
        }
    }
}

export default connect()(withTranslation("translations")(ShowmessageContest));
